/**
 * MSapling Routing Utilities
 * (TS Migrated)
 */

const hostname: string = window.location.hostname || "";

const normalizeBase = (base: string): string => {
  if (!base) return "";
  return base.replace(/\/+$/, "");
};

const isPrivateIpv4 = (h: string): boolean => {
  if (/^127\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  if (/^192\.168\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  const m = /^172\.(\d{1,2})\.\d{1,3}\.\d{1,3}$/.exec(h);
  if (m) {
    const oct = Number(m[1]);
    return oct >= 16 && oct <= 31;
  }
  return false;
};

const isLocalHostName: boolean =
  hostname === "localhost" ||
  hostname.endsWith(".local") ||
  isPrivateIpv4(hostname);

const defaultLocalApi: string = `${window.location.protocol}//${hostname || "localhost"}:8000`;

export const API_DEFAULTS = {
  local: defaultLocalApi,
  prod: "https://api.msapling.com",
};

export const ROUTES = {
  authLogin: "/auth/login",
  authRegister: "/auth/register",
  authLogout: "/auth/logout",
  authForgotPassword: "/auth/forgot-password",
  authGuest: "/auth/guest",
  usersMe: "/users/me",
  explorerCmd: "/explorer/list",
  uploadText: "/api/upload_text",
  chatUpload: "/chat/upload",
  benchmarkExport: "/api/benchmark/export",
};

export const resolveApiBase = (): string => {
  // @ts-ignore - process.env might not be defined in all environments
  const envApiUrl = (process.env.REACT_APP_API_URL || "").trim();
  if (envApiUrl) return normalizeBase(envApiUrl);
  return normalizeBase(isLocalHostName ? API_DEFAULTS.local : API_DEFAULTS.prod);
};
